package com.example.mystybag.appCore.logic

import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_DELIVERY
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_FAVORITES
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_HOME
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_PROFILE
import com.example.mystybag.appCore.logic.NavigatorSelectPage
import com.example.mystybag.appCore.model.pages.DeleteAccountRequestUIState
import com.example.mystybag.common.resources.SR
import com.example.mystybag.communication.common.CommonCommands
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_DELETE_ACCOUNT_REQUEST_PENDING
import com.example.mystybag.core.expected.Preferences.getBoolean
import com.example.mystybag.core.expected.Preferences.setBoolean
import com.example.mystybag.core.helpers.GlobalCommonData
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.MainCallback
import com.example.mystybag.sharedmodels.mystyBag.requestModels.DeleteAccountRequestRequestModel

class DeleteAccountRequestViewModel(context: AppContext) :
    ChildViewModel<DeleteAccountRequestUIState>(context, DeleteAccountRequestUIState()) {

    override fun onCreate() {
        navControls.title = sharedString(SR.strings.delete_account)
        navControls.backButtonVisible = true
        val hasPending = getBoolean(PREFERENCES_DELETE_ACCOUNT_REQUEST_PENDING, false)
        updateState { it.copy(hasPendingRequest = hasPending) }
    }

    fun onEnquiryChanged(text: String) {
        updateState { it.copy(enquiryText = text) }
    }

    fun onBackClick() {
        goBack()
    }

    fun onWebHeaderHomeClick() {
        setResult<MainCallback> { popToMainAndNavigate(NavigatorSelectPage(PAGE_HOME)) }
    }

    fun onWebHeaderOrdersClick() {
        setResult<MainCallback> { popToMainAndNavigate(NavigatorSelectPage(PAGE_DELIVERY)) }
    }

    fun onWebHeaderFavoritesClick() {
        setResult<MainCallback> { popToMainAndNavigate(NavigatorSelectPage(PAGE_FAVORITES)) }
    }

    fun onWebHeaderMenuClick() {
        setResult<MainCallback> { popToMainAndNavigate(NavigatorSelectPage(PAGE_PROFILE)) }
    }

    fun onSubmitClick() {
        val text = uiState.value.enquiryText.trim()
        if (text.isBlank()) return
        updateState { it.copy(isLoading = true) }
        commandBlock(showProgress = true) {
            CommonCommands.sendDeleteAccountRequest(
                DeleteAccountRequestRequestModel(
                    userId = GlobalCommonData.userId,
                    message = text
                )
            ).onResponse(
                success = {
                    launchOnMain {
                        setBoolean(PREFERENCES_DELETE_ACCOUNT_REQUEST_PENDING, true)
                        updateState { it.copy(isLoading = false) }
                        showSnackbar(SR.strings.delete_account_request_sent)
                        goBack(null)
                    }
                },
                baseError = { response ->
                    launchOnMain {
                        updateState { it.copy(isLoading = false) }
                        showSnackbar(com.example.mystybag.communication.utils.Response.getErrorMessage(response.status, response.apiEndPoint, response.statusMessage))
                    }
                }
            )
        }
    }
}
